import { gql } from "@apollo/client";

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($organization: organization_insert_input!) {
    insert_organization_one(object: $organization) {
      id
    }
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation DeleteOrganization($id: uuid!) {
    delete_organization_by_pk(id: $id) {
      id
    }
  }
`;
